import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { FormTaxResponse } from 'src/app/models/tax.model';
import { TaxService } from 'src/app/services/tax.service';

@Component({
  selector: 'app-modal-tax-return',
  templateUrl: './modal-tax-return.component.html',
  styleUrls: ['./modal-tax-return.component.scss']
})
export class ModalTaxReturnComponent {
  @Input() formList = [];
  @Output() close = new EventEmitter<any>();

  constructor(
    private toastService: ToastrService,
    private taxService: TaxService
  ) {

  }

  readyToPay(form: FormTaxResponse) {
    if (form.paying.loading) {
      return;
    }
    form.paying.loading = true;
    var formId = form.id;
    var request = { formId: formId, description: 'Reporte de formulario pagado.' };
    this.taxService.readyToPay(formId, request).subscribe({
      next: (response: ResponseObject) => {
        form.paying.loading = false;
        this.toastService.success("Pronto verificaremos tu pago y tu formulario quedará declarado.");
        this.close.emit(true);
      },
      error: (error) => {
        form.paying.loading = false;
        this.toastService.error(error.data.message);
      }
    });
  }

  downloadForm(form: FormTaxResponse) {
    if (form.downloading.loading) {
      return;
    }
    form.downloading.loading = true;
    var formId = form.id;
    this.taxService.downloadForm(formId).subscribe((blob) => {
      form.downloading.loading = false;
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = 'form.pdf';
      link.click();
      window.URL.revokeObjectURL(url);
    }, (error) => {
      form.downloading.loading = false;
      this.toastService.error("No se encontró el archivo");
    });
  }
}
